import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
})
export class CardComponent implements OnInit {
  @Input() checked = false;
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() displayValue: string = '';
  constructor() {}

  ngOnInit(): void {}
}
